import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'cc-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  @Input() id: string;
  @Input() modelValue: boolean;
  @Input() labelText: string;
  @Input() labelClass?: string;

  @Output() onUpdate = new EventEmitter<void>();
  @Output() modelValueChange = new EventEmitter<boolean>();

  @Input()
  @HostBinding('class')
  hostClass: string;

  updateCheckboxValue() {
    this.modelValueChange.emit(!this.modelValue);
    this.onUpdate.emit();
  }
}
